<template>
  <v-container>
    <v-card v-if="isErrorParam" flat outlined class="ma-5 pa-3">
      <div class="subtitle-2 mb-2">
        <v-icon class="mr-1" color="primary" small>mdi-information-outline</v-icon>
        <span class="primary--text">分析・診断サービスお見積り情報にアクセスできません</span>
      </div>
      <p class="caption">
        分析・診断サービス申し込み情報にアクセスできません。<br>
        <br>
        すでに削除されている情報を開こうとしているか、他の事業所の申し込み情報にアクセスしています。<br>
        もう一度お申込みページからアクセスしてください。<br>
      </p>
      <v-btn icon :to="{ path: '/' }">
        <v-icon>mdi-arrow-left</v-icon>
      </v-btn>お申込みページに戻る
    </v-card>

    <div v-if="!isErrorParam" class="nonprint">
        <v-btn icon :to="returnPath">
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>
        <span class="display-1 px-3">分析・診断サービス お見積書</span>

    </div>
    <div class="ml-2 my-2 nonprint">
        <v-chip v-bind="getApplicationStatus(this.quote.Status,1)" class="mr-2">
        {{getApplicationStatus(this.quote.Status,1).text}}</v-chip>
        {{getApplicationStatus(this.quote.Status,1).message}}
    </div>
    <v-card v-if="!isErrorParam" flat outlined class="pa-2 nonprint">

      <v-btn 
        small 
        rounded 
        color="amber" 
        @click="print()"
        class="mx-3"
        id="ordersheet_btn"
        >
        <v-icon class="mr-2">mdi-printer</v-icon>
        お見積書を印刷する
      </v-btn>
      <p class="mx-3 mt-3 caption">
        ※ご利用の環境（OSやブラウザのバージョンやプリンターなど）によって印刷レイアウトが崩れる場合があります。印刷レイアウトが崩れる場合は、お手数ですが余白や印刷範囲を設定して印刷してください。
      </p>

      <p v-if="!isValidQuote" class="mx-3 my-1 red--text">
        このお見積りは有効期限が切れています。
      </p>
      
      <v-btn 
        small 
        rounded 
        color="amber" 
        @click="gotoApplication()"
        class="mx-3 mt-5"
        v-bind:disabled="!isActivateButton(this.quote.Status).application"
        >
        <v-icon class="mr-2">mdi-plus</v-icon>
        お見積り内容で申し込む
      </v-btn>
      <v-btn 
        small 
        rounded 
        color="amber" 
        @click="editQuote()"
        class="mx-3 mt-5"
        v-bind:disabled="!isActivateButton(this.quote.Status).edit"
        >
        <v-icon class="mr-2">mdi-lead-pencil</v-icon>
        お見積り内容を確認／訂正する
      </v-btn>
      <v-btn 
        small 
        rounded 
        color="amber" 
        @click="isCancelConfirmed = true"
        class="mx-3 mt-5"
        v-bind:disabled="!isActivateButton(this.quote.Status).cancel"
        >
        <v-icon class="mr-2">mdi-delete</v-icon>
        お見積りをキャンセルする
      </v-btn>
      <v-btn 
        small 
        rounded 
        color="amber" 
        @click="referQuote()"
        class="mx-3 mt-5"
        >
        <v-icon class="mr-2">mdi-card-search-outline </v-icon>
        お見積り内容を参照する
      </v-btn>    </v-card>

    <div v-if="!isErrorParam" class="mt-3">

      <!-- 横幅A4サイズ調整 -->
      <v-card flat class="pa-0" width="210mm" style="margin: 0 auto">
        <div v-for="QuoteDatailsPage in QuoteDatails" :key="QuoteDatailsPage.page">
          <!-- ヘッダ（1ページ目） -->
          <v-card v-if="QuoteDatailsPage.page==1" flat class="px-0 mx-0">
            <v-row dense>
              <!-- 宛名 -->
              <v-col cols=5>
                <div class="quote-address">{{quote.OrdererCompanyName}}</div>
                <div class="quote-address">{{quote.OrdererOfficeName}}</div>
                <div class="quote-address"> {{orderer.DeptName}}</div>
                <div class="quote-address-name">{{quote.OrdererName}} 様</div>
              </v-col>
              <!-- サブヘッダ 発行日 -->
              <v-col cols=2>
              </v-col>
              <v-col cols=5>
                <v-simple-table dense>
                  <template v-slot:default>
                    <tbody>
                      <tr> 
                        <td>
                          <div class="quote-header_just">見積日</div>
                        </td>
                        <td>
                          <div class="quote-header_just">{{ quote.IssuedAt| moment('YYYY[年]MM[月]DD[日]') }}</div>
                        </td>
                      </tr>
                      <tr> 
                        <td>
                          <div class="quote-header_just">見積No</div>
                        </td>
                        <td>
                          {{quote.id}}
                        </td>
                      </tr>
                      <tr> 
                        <td>
                          <div class="quote-header_just">ページ数</div>
                        </td>
                        <td>
                          {{QuoteDatailsPage.page}} / {{QuoteDatails.length}}
                        </td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-col>
            </v-row>
          </v-card>

          <!-- ヘッダ（2ページ目以降） -->
          <v-card v-if="QuoteDatailsPage.page>1" flat class="px-0 mx-0">
            <v-row dense>
              <!-- 宛名 -->
              <v-col cols=5>
              </v-col>
              <!-- サブヘッダ 発行日 -->
              <v-col cols=2>
              </v-col>
              <v-col cols=5>
                <v-simple-table class="mb-5" dense>
                  <template v-slot:default>
                    <tbody>
                      <tr> 
                        <td>
                          <div class="quote-header_just">見積日</div>
                        </td>
                        <td>
                          <div class="quote-header_just">{{ quote.IssuedAt| moment('YYYY[年]MM[月]DD[日]') }}</div>
                        </td>
                      </tr>
                      <tr> 
                        <td>
                          <div class="quote-header_just">見積No</div>
                        </td>
                        <td>
                          {{quote.id}}
                        </td>
                      </tr>
                      <tr> 
                        <td>
                          <div class="quote-header_just">ページ数</div>
                        </td>
                        <td>
                          {{QuoteDatailsPage.page}} / {{QuoteDatails.length}}
                        </td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-col>
            </v-row>
          </v-card>

          <v-card v-if="QuoteDatailsPage.page==1" flat class="px-0 mx-0">
            <v-row>
              <v-col cols=7>
                <v-row dense>
                  <v-col cols=12>
                    <div class="printable-title">見 積 書</div>
                    <div class="printable-caption">毎度お引き立てに預かり厚く御礼申し上げます。</div>
                    <div class="printable-caption">お引き合いの件、下記の通りお見積申し上げますので</div>
                    <div class="printable-caption">何卒ご用命下さいますようお願い申し上げます。</div>
                  </v-col>
                  <v-col cols=12>
                    <v-simple-table dense>
                      <template v-slot:default>
                        <tbody>
                          <tr> 
                            <td style="width:35%">
                              <div class="quote-header_just">納期</div></td>
                            <td><div class="quote-header">備考欄ご参照</div></td>
                          </tr>
                          <tr> 
                            <td><div class="quote-header_just">報告書受渡</div></td>
                            <td><div class="quote-header">貴社ご指定場所</div></td>
                          </tr>
                          <tr> 
                            <td><div class="quote-header_just">御支払条件</div></td>
                            <td><div class="quote-header">分析報告書納入月の翌月末現金振込</div></td>
                          </tr>
                          <tr> 
                            <td><div class="quote-header_just">見積有効期限</div></td>
                            <td><div class="quote-header">{{ quote.ValidityAt| moment('YYYY[年]MM[月]DD[日]') }}</div></td>
                          </tr>
                        </tbody>
                      </template>
                    </v-simple-table>
                  </v-col>

                  <v-col cols=12 dense>
                    <v-simple-table dense class="ma-0 pa-0">
                      <template v-slot:default>
                        <tbody >
                          <tr> 
                            <td rowspan=2 valign="center" align="right" style="width:30%; border-bottom: none;" class="pt-2">
                              <div class="amount-title">合計金額</div>
                            </td>
                            <td style="width:70%; border-bottom: none;">
                              <div class="amount ml-2">{{Number(DiscountedTotalFee).toLocaleString()}} 円</div>
                              <div class="amount-caption mt-2 ml-2">※上記金額には消費税は含まれておりません。</div>
                            </td>
                          </tr>
                        </tbody>
                      </template>
                    </v-simple-table>
                  </v-col>
                </v-row>

              </v-col>

              <v-col cols=5>
                <v-row dense>
                  <v-col cols=12>
                    <div align="center">
                      <img class="company-seal2 nonprint" src="/img/company-seal-dummy.png" width="300px">
                      <img class="company-seal2 onlyprint" src="/img/company-seal01.png" width="280px">
                    </div>
<!--
                    <div class="company-seal">
                      <v-img
                        max-width="150"
                        src="/img/company-seal.png"
                      ></v-img>
                      <v-img
                        class="company-logo"
                        src="/img/logo.gif"
                      ></v-img>
                    </div>
-->
                  </v-col>
                  <v-col cols=12>
                    <v-simple-table dense>
                      <template v-slot:default>
                        <tbody>
                          <tr> 
                            <td class="company-info-table"><div class="company-info">本社</div></td>
                          </tr>
                          <tr> 
                            <td rowspan=2 class="company-info-table" style="width: 35%;" valign="top" >
                              <div class="company-info">〒252-0328</div>
                            </td>
                            <td class="company-info-table">
                              <div class="company-info"> 神奈川県相模原市南区麻溝台</div>
                            </td>
                          </tr>
                          <tr> 
                            <td class="company-info-table"><div class="company-info">１－１２－１</div></td>
                          </tr>
                          <tr> 
                            <td colspan=2><div class="company-info">TEL：042-705-3636 ／ FAX：042-705-3631</div></td>
                          </tr>
                        </tbody>
                      </template>
                    </v-simple-table>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card>

          <!-- 明細行 -->
          <v-data-table
            :headers="QuoteDatailsHeaders"
            :items="QuoteDatailsPage.rows"
            :items-per-page=100
            hide-default-footer
            dense
            class="elevation-1 ml-1 mr-1 mt-3 pa-0 sample-table"
          >
            <template v-slot:[`item.Name`]="{ item }">
              <div v-if="item.Name && getBytes(item.Name) >= 42" class="sample-table-text2">{{item.Name}}</div>
              <div v-else class="sample-table-text">{{item.Name}}</div>
            </template>
            <template v-slot:[`item.AnalizeName`]="{ item }">
             
             <div v-if="item.AnalizeName && getBytes(item.AnalizeName)>= 60" class="sample-table-text2"><span v-if="item.isSetAnamizeItem" class="ml-4"></span>{{item.AnalizeName}}</div>
             <div v-else class="sample-table-text"><span v-if="item.isSetAnamizeItem" class="ml-4"></span>{{item.AnalizeName}}</div>
            </template>
            <template v-slot:[`item.Require`]="{ item }">
             <span v-if="item.Require" class="sample-table-text">{{Number(item.Require).toLocaleString()}}</span>
            </template>
            <template v-slot:[`item.Count`]="{ item }">
             <span class="sample-table-text">{{item.Count}}</span>
            </template>
            <template v-slot:[`item.Price`]="{ item }">
             <span v-if="item.Price" class="sample-table-text">{{Number(item.Price).toLocaleString()}}</span>
            </template>
            <template v-slot:[`item.Amount`]="{ item }">
              <span v-if="item.Amount" class="sample-table-text">{{Number(item.Amount).toLocaleString()}}</span>
            </template>
          </v-data-table>

          <!-- フッタ（1ページ目） -->
          <v-simple-table v-if="QuoteDatailsPage.page==1" class="ml-1 mr-1 quote-remarks-table" dense>
            <template v-slot:default>
              <tbody>
                <tr> 
                  <td rowspan=5 valign="top" style="width:70%;" class="pt-2">
                    <div class="quote-remarks-header mb-2">備考</div>
                    <div class="quote-remarks-text" >
                      ・納期：サンプル到着後15営業日をご予定願います。<br>
                      （稼働状況、見積内容に応じて変動する可能性があります）<br>
                      ・試験法は公的規格を参考にした、弊社独自規格による試験です。<br>
                      ・本件に必要なオイルサンプル量は上記の通りですが、余裕をもってご準備ください。<br>
                      ・サンプル残量返却ご希望の場合は貴社着払にてご返却させて頂きます。
                    </div>
                  </td>
                </tr>
                <tr> 
                  <th style="width:15%">
                    <div class="quote-remarks-header my-1">小計</div>
                  </th>
                  <td style="width:15%">{{Number(QuoteDatailsPage.subAmount).toLocaleString()}} 円</td>
                </tr>
                <tr> 
                  <th>
                    <div class="quote-remarks-header my-1">総計</div>
                  </th>
                  <td>{{Number(quote.Fee).toLocaleString()}} 円</td>
                </tr>
                <tr> 
                  <th>
                    <div class="quote-remarks-header my-1">Web割引</div>
                  </th>
                  <td>
                    -{{Number(quote.Discount.discount).toLocaleString()}} 円
                  </td>
                </tr>
                <tr> 
                  <th class="quote-remarks-amount1">
                    <div class="quote-remarks-header my-2">
                      総合計
                    </div>
                  </th>
                  <td class="quote-remarks-amount2">
                    {{Number(DiscountedTotalFee).toLocaleString()}} 円
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>

          <!-- フッタ（2ページ目以降） -->
          <v-simple-table v-if="QuoteDatailsPage.page>1" class="ml-1 mr-1 quote-remarks-table" dense>
            <template v-slot:default>
              <tbody >
                <tr> 
                  <td rowspan=3 valign="top" style="width:70%;" class="pt-2">
                    <div class="quote-remarks-header" style="font-weight:bold">備考</div>
                    <div class="quote-remarks-text">
                    </div>
                  </td>
                  <td style="width:15%" class="quote-remarks-subtotal">
                     <div class="quote-remarks-header my-2">小計</div>
                  </td>
                  <td style="width:15%" class="quote-remarks-subtotal">{{Number(QuoteDatailsPage.subAmount).toLocaleString()}} 円</td>
                </tr>
                <tr> 
                  <td style="width:15%" class="quote-remarks-subtotal2"></td>
                  <td style="width:15%" class="quote-remarks-subtotal2"></td>
                </tr>

              </tbody>
            </template>
          </v-simple-table>

          <div class="pagebreak"></div>

        </div>

      <img class="onlyprint" src="/img/J20-28-25-040_1_Precautions_1.jpg" width="100%">
        <div class="pagebreak"></div>
      <img class="onlyprint" src="/img/J20-28-25-040_1_Precautions_2.jpg" width="100%">

      </v-card>



        <v-overlay absolute :value="overlayStepper1" opacity="0.8" color="white">
          <v-progress-circular indeterminate size="64" color="amber"></v-progress-circular>
        </v-overlay>

    </div>
  
  
  
    <v-dialog
      v-model="isCancelConfirmed"
      persistent
      max-width="50%"
    >
      <v-card class="px-3 py-2">
        <v-card-title class="headline">
          <v-icon class="mr-1" color="red" large>mdi-information-outline</v-icon>
            このお見積りをキャンセルしてもよろしいですか？
        </v-card-title>

        <v-card-actions>
            <v-spacer></v-spacer>
          <v-btn
            color="grey darken-4"
            outlined
            rounded
            elevation="2"
            class="mr-3"
            @click="isCancelConfirmed = false"
          >
            キャンセルしない
          </v-btn>
          <v-tooltip top color="grey darken-4">
            <template v-slot:activator="{ on }">
              <v-btn 
              v-on="on"
              rounded 
              color="red" 
              @click="cancelQuote()" 
              :disabled="processing"
              data-createQuote 
              class="white--text px-2"
              >
                <v-icon class="mr-2">mdi-delete</v-icon>
                  キャンセルする
              </v-btn> 
            </template>
            <span>お見積依頼をキャンセルします</span>
          </v-tooltip>

        </v-card-actions>
      </v-card>
    </v-dialog>  
  
  
  </v-container>
</template>

<script>
//import moment from 'moment'
import { API, graphqlOperation} from "aws-amplify"
import { getApplication, samplesByApplication } from '../graphql/queries'
import { updateApplication } from "../graphql/mutations"
//import { officeByKey } from '../graphql/queries'
import { employeeByKey } from '../graphql/queries'
import mixin  from '../utils/mixin.js'
import utils  from '../utils/utils.js'

export default {
  mixins:[ mixin, utils],
  components: {
  },
  head: {
    title: { inner: '分析依頼 御見積書'},
  },
  data: () => ({
    quoteid: "",
    appid: "",
    quote: {},
    isValidQuote: true,
    orderer:{},
    delvOffice: {},
    payOffice: {},
    delvEmployee: {},
    payEmployee: {},
    samples: [],
    sampleNum: 0,
    overlayStepper1: true,
    isErrorParam: false,
    isCancelConfirmed: false,
    processing: false,
    ErrorInfo: "",

    Ratio: 0,
    Rounding: 0,

    DiscountedTotalFee: 0,

    QuoteDatails: [],
    QuoteDatailsHeaders: [
      { 
        text: '件名', 
        value: 'Name',
//        divider: true,
        sortable: false,
        width: "22%",
        align: "start"
      },
      {
        text: '分析項目',
        value: 'AnalizeName',
//        divider: true,
        sortable: false,
        width: "30%",
      },
      { text: 'ｻﾝﾌﾟﾙ量', 
        value: 'Require',
//        divider: true,
        sortable: false,
        align: 'end' ,
        width: "11%",
      },
      {
        text: '数量', 
        value: 'Count',
//        divider: true,
        sortable: false,
        align: 'end' ,
        width: "8%",
      },
      {
        text: '単位', 
        value: 'Unit',
//        divider: true,
        sortable: false,
        align: 'end' ,
        width: "8%",
      },
      {
        text: '単価', 
        value: 'Price',
//        divider: true,
        sortable: false,
        align: 'end' ,
        width: "8%",
      },
      {
        text: '金額', 
        value: 'Amount',
//        divider: true,
        sortable: false,
        align: 'end' ,
        width: "10%",
      },
    ],

  }),
  mounted: async function () {
    this.Ratio = Number(this.$store.state.operatingCompany.Ratio) / 100
    this.Rounding = this.$store.state.operatingCompany.Rounding

    this.quoteid = this.$route.query.id

    if(this.$route.query.appid != undefined) {
      this.appid = this.$route.query.appid
    }

    let application = await API.graphql(graphqlOperation(getApplication, {id: this.quoteid}))

      // 参照依頼情報のアクセスチェック
      // 存在しない依頼情報、他事業所の依頼情報を開いた場合はアクセス不正でエラーにする
      if(!application.data.getApplication) {
        this.isErrorParam = true
        this.ErrorInfo = "notExist"
        this.overlayStepper1 = false
        console.log('isErrorParam: ', this.isErrorParam)
        return
      }
      if(this.$store.state.isStaff == false) {
        if(application.data.getApplication.OfficeID != this.$store.state.operatingOffice.OfficeID) {
          this.isErrorParam = true
          this.ErrorInfo = "illegalAccess"
          this.overlayStepper1 = false
          console.log('isErrorParam: ', this.isErrorParam)
          return
        }
      }
      this.initialize()
  },
  computed: {
    returnPath() {
      if(this.appid != "") {
        return { path: '/ReferApplication', query: { id: this.appid }}
      }
      if(this.$store.state.isStaff == true) {
        return "/staffpage"
      }else {
        return "/"
      }
    },
  },
  methods: {
/*
    numSampleID (sampleid) {
      return ( '000' + Number(sampleid) ).slice( -3 );
    },
*/
    isActivateButton(status) {
//      console.log("isActivateButton", status)
      switch(status){
        case "quoteIssued":
          return {edit: true, application: this.isValidQuote, cancel: true, refer: false}
        case "quoteRequest":
          return {edit: true, application: false, cancel: false, refer: false}
        case "quoteReturn":
          return {edit: true, application: this.isValidQuote, cancel: true, refer: false}
        case "quoteCanceled":
          return {edit: false, application: false, cancel: false, refer: false}
        default:
          return {edit: false, application: false, cancel: false, refer: false}
      }
    },
    gotoApplication: async function () {
      this.quoteid = this.$route.query.id
      this.$router.push("/application?id=" + this.quoteid)
    },
    editQuote: async function() {
      this.quoteid = this.$route.query.id
      this.$router.push("/quote?id=" + this.quoteid)
    },
    referQuote: async function() {
      this.quoteid = this.$route.query.id
      this.$router.push("/referquote?id=" + this.quoteid)
    },
    cancelQuote: async function() {
      console.log("cancelQuote")
      let quoteid = this.$route.query.id

      let application = {
        id: quoteid,
        Status: "quoteCanceled",
      }
      const updatedSample = await API.graphql(graphqlOperation(updateApplication, {input: application}))
      console.log('cancelQuote success', updatedSample)
      this.$router.push("/referquote?id=" + this.quoteid)
    },
    print: async function () {
      window.print()
    },
    initialize: async function() {
      let application = await API.graphql(graphqlOperation(getApplication, {id: this.quoteid}))

      this.quote = application.data.getApplication
      console.log("quote", this.quote)

//      this.AnalizeTypeCategory = this.getApplicationAnalizeTypeCategory(this.quote)
//      this.analizeTypeGroupList = await this.getAnalizeTypeGroupList(this.AnalizeTypeCategory)
//      this.oilTypeCategoryList = await this.getOilTypeCategoryList(this.AnalizeTypeCategory)

      // samplesByApplicationを使用してサンプルを取得
      let samples = await API.graphql(graphqlOperation(samplesByApplication, {ApplicationID: this.quoteid, limit: 999}))
      //サンプルID（連番）でソート
      let _samples = samples.data.samplesByApplication.items
      _samples.sort(function(a,b){
          if(a.SampleID < b.SampleID) return -1;
          if(a.SampleID > b.SampleID) return 1;
          return 0;
      });
      this.samples = _samples

      let now = this.getNow()
      if(this.quote.ValidityAt >= now) {
        console.log("見積有効", this.quote.ValidityAt)
        this.isValidQuote = true
      }else {
        console.log("見積無効", this.quote.ValidityAt)
        this.isValidQuote = false
      }

      this.quote.Discount = JSON.parse(this.quote.Discount)
      console.log("quote.Discount", this.quote.Discount)

      this.DiscountedTotalFee = this.quote.Fee - this.quote.Discount.discount
      console.log("discountedFee", this.DiscountedTotalFee)


      let _orderer = await API.graphql(graphqlOperation(employeeByKey, {EmployeeID: this.quote.OrdererID}))
      this.orderer = _orderer.data.employeeByKey.items[0]
      console.log("orderer", this.orderer)


/*
      let _delvOffice = await API.graphql(graphqlOperation(officeByKey, {OfficeID: this.application.DelvCompanyID + this.application.DelvOfficeID}))
      this.delvOffice = _delvOffice.data.officeByKey.items[0]

      let _payOffice = await API.graphql(graphqlOperation(officeByKey, {OfficeID: this.application.PayCompanyID + this.application.PayOfficeID}))
      this.payOffice = _payOffice.data.officeByKey.items[0]

      let _delvEmployee = await API.graphql(graphqlOperation(employeeByKey, {EmployeeID: this.application.DelvCompanyID + this.application.DelvOfficeID + this.application.DelvEmployeeID}))
      this.delvEmployee = _delvEmployee.data.employeeByKey.items[0]

      let _payEmployee = await API.graphql(graphqlOperation(employeeByKey, {EmployeeID: this.application.PayCompanyID + this.application.PayOfficeID + this.application.PayEmployeeID}))
      this.payEmployee = _payEmployee.data.employeeByKey.items[0]

      this.barcodeValue = this.applicationid
      this.sampleNum = this.samples.length
*/

      //サンプル明細データ作成
      let QuoteDatails = []
      let QuoteDatailsPage = []
      let rowsperPage = 17
      let rowsperPage2 = 32
      let pages = 1
      let samplesRow = []
      let lastSampleName = ""
      if (this.samples) {
        for (const sample of this.samples) {
          console.log("--- sample.Name", sample.Name)
          lastSampleName = sample.Name
          samplesRow = []
          let setSampleName = false
          // 分析区分の分析項目一覧取得
//          let analyseItemByType = this.$store.state.analizeItemList.filter(item => item.AnalizeType  == sample.AnalizeType)
          let analizeItemList = await this.getAnalizeItemList(sample.AnalizeType)
          // 分析区分の分析セット一覧取得
//          let analyseSetByType = this.$store.state.analizeSetList.filter(item => item.AnalizeType  == sample.AnalizeType)
          let analizeSetList = await this.getAnalizeSetList(sample.AnalizeType)
          let analizeItemSubList = await this.getAnalizeItemSubList(sample.AnalizeType)

          // セットの指定あり
          if(sample.AnalizeSet) {
            let _analyseSet = analizeSetList.filter(item => item.Value  == sample.AnalizeSet)
            let analyseSet = _analyseSet[0]
            console.log("analyseSet", analyseSet)
            let QuoteDatailRow = {}
            if(!setSampleName) {
              QuoteDatailRow.Name = sample.Name
              setSampleName = true
            }
//            QuoteDatailRow.AnalizeName = analyseSet[0].Text
            QuoteDatailRow.AnalizeName = analyseSet.Text
            QuoteDatailRow.isSetAnamizeItem = false
//            QuoteDatailRow.Require = analyseSet[0].Require
            QuoteDatailRow.Require = analyseSet.Require
            QuoteDatailRow.Count = sample.SameCount
            QuoteDatailRow.Unit = ""

//            QuoteDatailRow.Price = analyseSet[0].Price
//            QuoteDatailRow.Amount = analyseSet[0].Price * Number(sample.SameCount)
            QuoteDatailRow.Price = analyseSet.Price
            QuoteDatailRow.Amount = analyseSet.Price * Number(sample.SameCount)

            samplesRow.push(QuoteDatailRow)

            let analizeItems = []
            let analizeItemNames = []
            try {
//              analizeItems = JSON.parse(analyseSet[0].AnalizeItems)
              analizeItems = JSON.parse(analyseSet.AnalizeItems)
            } catch (e) {
//              const replaced = analyseSet[0].AnalizeItems.replace(/'/g,"\"")
              const replaced = analyseSet.AnalizeItems.replace(/'/g,"\"")
              analizeItems = JSON.parse(replaced)
            }

            try {
//              analizeItemNames = JSON.parse(analyseSet[0].AnalizeItemNames)
              analizeItemNames = JSON.parse(analyseSet.AnalizeItemNames)
            } catch (e) {
//              const replaced = analyseSet[0].analizeItemNames.replace(/'/g,"\"")
              const replaced = analyseSet.analizeItemNames.replace(/'/g,"\"")
              analizeItemNames = JSON.parse(replaced)
            }
            console.log("analizeItemNames", analizeItemNames)

//            for (var analizeItem of analizeItems) {
            for (var [index, analizeItem] of analizeItems.entries()) {
              QuoteDatailRow = {}
              let analiseItemObj = analizeItemList.filter(item => item.Value  == analizeItem)
              if(analiseItemObj.length != 0) {
                QuoteDatailRow.Name = ""
                QuoteDatailRow.AnalizeName = analiseItemObj[0].Text
                QuoteDatailRow.isSetAnamizeItem = true
                QuoteDatailRow.Require = "" //analiseItem[0].Require
                QuoteDatailRow.Count = ""
                QuoteDatailRow.Unit = ""
                QuoteDatailRow.Price = ""
                QuoteDatailRow.Amount = ""
              }else {
                QuoteDatailRow.Name = ""
//                QuoteDatailRow.AnalizeName = analizeItem
                QuoteDatailRow.AnalizeName = analizeItemNames[index]
                QuoteDatailRow.isSetAnamizeItem = true
                QuoteDatailRow.Require = "" //analiseItem[0].Require
                QuoteDatailRow.Count = ""
                QuoteDatailRow.Unit = ""
                QuoteDatailRow.Price = ""
                QuoteDatailRow.Amount = ""
              }

              samplesRow.push(QuoteDatailRow)
            }
          }

          // 個別分析項目指定あり
          let analizeItems = []
          if(sample.AnalizeItems) {
            try {
              analizeItems = JSON.parse(sample.AnalizeItems)
              console.log("analizeItems:", analizeItems)
            } catch (e) {
              const replaced = sample.AnalizeItems.replace(/'/g,"\"")
              console.log('replaced', replaced)
              analizeItems = JSON.parse(replaced)
            }

            // 注：AnalizeItemSubは2回戻す必要あり（明確な原因未解明）
            let a = JSON.parse(sample.AnalizeItemSub)
            console.log("analizeItemSub:", a)
            let analizeItemSub = JSON.parse(a)
            console.log("analizeItemSub:", analizeItemSub)

            for (analizeItem of analizeItems) {
              let _analiseItemObj = analizeItemList.filter(item => item.Value  == analizeItem)
              let analiseItemObj = _analiseItemObj[0]
              let QuoteDatailRow = {}
              if(!setSampleName) {
                QuoteDatailRow.Name = sample.Name
                setSampleName = true
              }
              QuoteDatailRow.AnalizeName = analiseItemObj.Text
              QuoteDatailRow.isSetAnamizeItem = false
              QuoteDatailRow.Require = analiseItemObj.Require
              QuoteDatailRow.Count = sample.SameCount
              QuoteDatailRow.Unit = ""

//              QuoteDatailRow.Price = analiseItemObj[0].Price
//              QuoteDatailRow.Amount = analiseItemObj[0].Price * Number(sample.SameCount)

              let fee = this.getAnalizeItemFee(analiseItemObj,this.Ratio,this.Rounding)
              QuoteDatailRow.Price = fee
              QuoteDatailRow.Amount = fee * Number(sample.SameCount)

              samplesRow.push(QuoteDatailRow)

              if(analizeItemSub) {
                let _analizeItemSub = analizeItemSub[analizeItem]
                console.log("_analizeItemSub:", analizeItem + " is " + _analizeItemSub)
                if(_analizeItemSub) {
                  let _analizeItemSubList = analizeItemSubList[analizeItem]
                  for (const _analizeItem of _analizeItemSub) {
                    let item = _analizeItemSubList.filter(item => item.Value  == _analizeItem)
                    let QuoteDatailRow = {}
                    QuoteDatailRow.AnalizeName = item[0].Text
                    QuoteDatailRow.isSetAnamizeItem = false
                    QuoteDatailRow.Require = item[0].Require
                    QuoteDatailRow.Count = sample.SameCount
                    QuoteDatailRow.Unit = ""

                    let fee = this.getAnalizeItemFee(item[0],this.Ratio,this.Rounding)
                    QuoteDatailRow.Price = fee
                    QuoteDatailRow.Amount = fee * Number(sample.SameCount)

                    samplesRow.push(QuoteDatailRow)
                  }
                }
              }




            }
          }

          // フィルター返却あり
          if(sample.Filter != "001") {
            let QuoteDatailRow = {}
            switch (sample.Filter) {
              case "003": // ラミネート加工なし 600円
                QuoteDatailRow.AnalizeName = "ﾌｨﾙﾀｰ返却・ﾗﾐﾈｰﾄなし"
                QuoteDatailRow.isSetAnamizeItem = false
                QuoteDatailRow.Require = ""
                QuoteDatailRow.Count = sample.SameCount
                QuoteDatailRow.Unit = ""
                QuoteDatailRow.Price = "600"
                QuoteDatailRow.Amount = 600 * sample.SameCount
                break
              default: // ラミネート加工 1700円
                QuoteDatailRow.AnalizeName = "ﾌｨﾙﾀｰ返却・ﾗﾐﾈｰﾄあり"
                QuoteDatailRow.isSetAnamizeItem = false
                QuoteDatailRow.Require = ""
                QuoteDatailRow.Count = sample.SameCount
                QuoteDatailRow.Unit = ""
                QuoteDatailRow.Price = "1700"
                QuoteDatailRow.Amount = 1700 * sample.SameCount
                break
            }
            samplesRow.push(QuoteDatailRow)
          }

          // (1) 処理中のサンプルを追加しても1ページに収まるか
          if(QuoteDatailsPage.length + samplesRow.length <= rowsperPage) {
            console.log("set 1", QuoteDatailsPage.length + "+" + samplesRow.length + "/" + rowsperPage)
            Array.prototype.push.apply(QuoteDatailsPage, samplesRow);
            console.log("QuoteDatailsPage", QuoteDatailsPage)

          // (2) サンプル分1ページに収まらない
          }else {
            console.log("(2)", QuoteDatailsPage.length + "+" + samplesRow.length + "/" + rowsperPage)
            // (2)-1 残っている（未追加分の）明細行があるか
            //       残りがあった場合、空行を入れて改ページ
            if(QuoteDatailsPage.length > 0) {
              console.log("(2)-1", QuoteDatailsPage.length + "/" + rowsperPage)
              // 設定済みのページの不足分を空行で補う
              let blankrows = rowsperPage - QuoteDatailsPage.length
              for(let i=0; i < blankrows; i++){
                QuoteDatailsPage.push({})
              }

              // 明細行（1ページ分）を追加（改ページ）
              // 小計（ページ毎金額）計算
              let subAmount = 0
              for (let detailPage of QuoteDatailsPage) {
                if(detailPage.Amount) subAmount = subAmount + Number(detailPage.Amount)
              }
              QuoteDatails.push({page: pages, rows: QuoteDatailsPage, subAmount: subAmount})
              // 2ページ目以降の行数に変更
              rowsperPage = rowsperPage2
              pages++
              QuoteDatailsPage = []
            }

            // (3) 処理中のサンプル情報を追加
            // (3)-1 1サンプルが1ページに収まる
            if(samplesRow.length <= rowsperPage) {
              QuoteDatailsPage = []
              Array.prototype.push.apply(QuoteDatailsPage, samplesRow);
            // (3)-2 1サンプルが1ページに収まらない
            }else {
/*              
                // 設定済みのページの不足分を空行で補う
                let blankrows = rowsperPage - QuoteDatailsPage.length
                for(let i=0; i < blankrows; i++){
                  QuoteDatailsPage.push({})
                }

                // 小計（ページ毎金額）計算
                let subAmount = 0
                for (let detailPage of QuoteDatailsPage) {
                  if(detailPage.Amount) subAmount = subAmount + Number(detailPage.Amount)
                }

                // 明細行（1ページ分）を追加
                QuoteDatails.push({page: pages, rows: QuoteDatailsPage, subAmount: subAmount})
                QuoteDatailsPage = []
                pages++
*/
              for(let i=0; i < samplesRow.length + rowsperPage;){
                // (3)-3 1ページ分設定
                console.log("(3)-3", {from:i, to:rowsperPage})
                let samplesRow1 = samplesRow.slice(i, i+rowsperPage);  //1ページ分抜く
                Array.prototype.push.apply(QuoteDatailsPage, samplesRow1);
                console.log("(3)-3", {from:i, to:i+rowsperPage, count:QuoteDatailsPage.length})
                i = i + rowsperPage

                // (3)-4 1ページ分埋まってしまった場合
                //       1ページ分出力して改ページ
                if(QuoteDatailsPage.length >= rowsperPage) {
                  // 小計（ページ毎金額）計算
                  let subAmount = 0
                  for (let detailPage of QuoteDatailsPage) {
                    if(detailPage.Amount) subAmount = subAmount + Number(detailPage.Amount)
                  }
                  // 出力する1行目には件名をセット
                  QuoteDatailsPage[0].Name = lastSampleName
                  QuoteDatails.push({page: pages, rows: QuoteDatailsPage, subAmount: subAmount})
                  rowsperPage = 33
                  pages++
                  QuoteDatailsPage = []
                }
              }
              if(QuoteDatailsPage.length > 0) {
                QuoteDatailsPage[0].Name = lastSampleName
                console.log("あまり",{QuoteDatailsPage:QuoteDatailsPage, lastSampleName:lastSampleName} )
              }
            }
          }
        }

        // サンプル返却を希望している場合
        console.log("quote.hasSurplus", this.quote.hasSurplus)
        if(this.quote.hasSurplus == "true") {
            QuoteDatailsPage.push({
              Name: "その他",
              AnalizeName: "サンプル返却手数料",
              isSetAnamizeItem: false,
              Require: "",
              Count: 1,
              Unit: "",
              Price: "1800",
              Amount: "1800"
            })
        }
        console.log("あまりある？", QuoteDatailsPage.length)

        // 未設定のページを追加
        if(QuoteDatailsPage.length > 0) {
          // 設定済みのページの不足分を空行で補う
          let blankrows = rowsperPage - QuoteDatailsPage.length
          for(let i=0; i < blankrows; i++){
            QuoteDatailsPage.push({})
          }

          let subAmount = 0
          for (let detailPage of QuoteDatailsPage) {
            if(detailPage.Amount) subAmount = subAmount + Number(detailPage.Amount)
          }
          QuoteDatails.push({page: pages, rows: QuoteDatailsPage, subAmount: subAmount})
        }
        this.QuoteDatails = QuoteDatails
      }
      this.overlayStepper1 = false
    },
  },
}
</script>

<style lang="scss" scoped >
  .onlyprint { 
    display: none;
  }

  .perforatedline {
    border: 0;
    border-top: 2px dashed #000;
    text-align: center;
    margin-top: 50px;
  }
 
  .perforatedline:after {
    background: #fff;
    content: '\002702  キ リ ト リ 線  \002702';
    display: inline-block;
    padding: 0 0.5em;
    position: relative;
    top: -0.7em;
  }

  .printable-title {
    font-family: serif;
    font-size : 28px;
    font-weight:bold;
    padding: 10px 5px 5px;
  }

  .printable-caption {
    font-family: serif;
    font-size : 12px !important;
    margin: 0px !important;
  }


  .quote-header_just {
    font-family: serif;
    font-size : 14px !important;
    -moz-text-align-last: justify;
    text-align-last: justify;
  }
  .quote-header {
    font-family: serif;
    font-size : 14px !important;
  }

  .quote-address {
    font-family: serif;
    font-size : 14px !important;
  }
  .quote-address-name {
    font-family: serif;
    font-size: 16px !important;
    border-bottom: 1px solid;
  }
  .company-seal {
//    position: relative;
//    left: 45%;
    width: "500px";
    height: "500px";
    background-image: url("/img/company-seal.png");
  }

  img.company-seal2 {
    width: "600px";
    height: "600px";
  }
  .company-logo {
    position: absolute;
    bottom: 30%;
    left: -80px;
  }

  .company-info-table {
    border:none !important;
  }
  .company-info {
    font-family: serif;
    font-size : 12px !important;
  }

  .amount-title {
    font-family: serif;
    font-size : 18px !important;
    font-weight:bold;
  }
  .amount {
    font-family: serif;
    font-size : 30px !important;
    text-align: center;
    border-bottom: 1px solid;
  }
  .amount-caption {
    font-family: serif;
    font-size : 11px !important;
  }

  .sample-table {
    border-radius: 0px 0px 0px 0px;
    border: 2px solid;
    border-bottom: none;
    font-family: serif;
  }

//  .sample-table table thead th {
//    border-bottom: 2px solid !important;
//    font-size : 10px !important;
//  }

//  .sample-table table tbody td {
//    padding-left: 10px;
//    font-size : 6px !important;
//   }

//  .v-data-table > .v-data-table__wrapper > table > tbody > tr
  .sample-table > .v-data-table__wrapper > table > tbody > tr > .text-start
//  .v-data-table > .v-data-table__wrapper > table > thead > tr > th,
//  .v-data-table > .v-data-table__wrapper > table > tfoot > tr > th ,
  {
      font-size:50px !important;
  }

  .sample-table-text {
//    padding-left: 5px;
    font-size : 10px !important;
  }

  .sample-table-text2 {
//    padding-left: 5px;
    font-size : 10px !important;
  }

  .quote-remarks-table {
    border-radius: 0px 0px 0px 0px;
    border: 2px solid;
    border-left: none
  }

  .quote-remarks-table tbody th{
    font-family: serif;
    border-left: 2px solid;
  }
  .quote-remarks-table tbody td{
    font-family: serif;
    border-left: 2px solid;
    text-align: right;
  }

  .quote-remarks-header {
    font-family: serif;
    font-size : 12px !important;
    font-weight:bold;
    text-align: left !important;
  }
  .quote-remarks-text {
    font-family: serif;
    font-size : 11px !important;
    text-align: left !important;
  }

  .quote-remarks-amount1 {
    font-family: serif;
    border: 4px double !important;
    border-right: none !important;
  }
  .quote-remarks-subtotal {
    font-family: serif;
    border-bottom: 2px solid !important;
    border-left: none;
  }
  .quote-remarks-subtotal2 {
    font-family: serif;
    border: none !important;
  }

  .quote-remarks-amount2 {
    font-family: serif;
    border: 4px double;
    border-left: none;
    text-align: right;
  }
  .quote-remarks-dummy {
    border-top: none !important;
  }
/* 
// 全体に適用されてしまうので書かない
// ページサイズを固定化したいのはOilMatrix専用ラベルシートのサイズ

@page {
  size: A4 portrait; // 横の場合はlandscape

  margin-top:    10.0mm;
  margin-bottom: 10.0mm;

  margin-left:   10.0mm;
  margin-right:  10.0mm;
}
*/
@media print {
  .nonprint { 
    display: none;
  }
  .printable-caption {
    font-size : 12px !important;
    margin: 0px !important;
  }
  .printable-title {
    font-family: serif;
    font-size : 28px;
    padding: 10px 5px 5px;
  }
  .printable-card-title {
    font-size : 16px !important;
  }
  .printable-card-body {
    font-size : 10px !important;
  }
  .quote-address {
    font-size : 14px !important;
  }

  .sample-table-text2 {
      width: 175%;
      font-size: 10px;
      -webkit-transform:scale(0.65);
      -moz-transform:scale(0.65);
      -ms-transform:scale(0.65);
      -o-transform:scale(0.65);
      transform:scale(0.65);
      transform-origin: left center;
  }

  .v-simple-table table {
    border-collapse: collapse !important;
    border-spacing: 0 !important;
  }
  
  .v-simple-table table td {
    padding: 4px 8px !important;
    line-height: 1.2 !important;
  }
  
  .v-simple-table table th {
    padding: 4px 8px !important;
    line-height: 1.2 !important;
  }

  .v-data-table table {
    border-collapse: collapse !important;
  }
  
  .v-data-table table td {
    padding: 4px 8px !important;
    line-height: 1.1 !important;
    height: auto !important;
  }
  
  /*
  .v-data-table table th {
    padding: 3px 8px !important;
    line-height: 1.1 !important;
    height: auto !important;
  }

  .sample-table.v-data-table table td {
    padding: 0 8px !important;
    line-height: 1.0 !important;
    height: auto !important;
  }
  
  .sample-table.v-data-table table th {
    padding: 0 8px !important;
    line-height: 1.0 !important;
    height: auto !important;
  }
  .sample-table.v-data-table .v-data-table__wrapper table tbody tr {
    height: auto !important;
  }
  .v-data-table--dense.sample-table > .v-data-table__wrapper > table > tbody > tr > td,
  .v-data-table--dense.sample-table > .v-data-table__wrapper > table > thead > tr > td,
  .v-data-table--dense.sample-table > .v-data-table__wrapper > table > tfoot > tr > td {
    height: 22px !important;
    min-height: 22px !important;
    max-height: 22px !important;
  }
  */


  .v-toolbar {
    display: none;
  }
  .v-content {
    padding: 0px !important;
  }
  .container {
    padding: 0px !important;
  }
  .v-sheet {
    padding: 0px !important;
  }
  .v-card {
    box-shadow: none !important ;
  }
  .pagebreak {
    page-break-before: always;
  }
  .onlyprint { 
    display: block;
  }
}
</style>

<style lang="scss">
.sample-table .v-data-table__wrapper table thead tr th {
  background-color: #e0e0e0 !important;
}

@media print {
  .v-data-table--dense.sample-table > .v-data-table__wrapper > table > tbody > tr > td,
  .v-data-table--dense.sample-table > .v-data-table__wrapper > table > thead > tr > td,
  .v-data-table--dense.sample-table > .v-data-table__wrapper > table > tfoot > tr > td {
    height: 24px !important;
    min-height: 24px !important;
    max-height: 24px !important;
  }
  
  .sample-table {
    margin-top: 10px !important;
  }
  
  .sample-table .v-data-table__wrapper table thead tr th {
    background-color: #d0d0d0 !important;
    -webkit-print-color-adjust: exact !important;
    color-adjust: exact !important;
  }
}
</style>